import { lte, gte, filter, contains, compose } from 'ramda';

const isAppleDevice = navigator.userAgent.match(/(iPhone|iPod|iPad)/) != null;

export const formatDateTimeForIOS = time => {
    const dateParts = time.substring(0,10).split('-');
    const timePart = time.substr(11);
    return dateParts[1] + '/' + dateParts[2] + '/' + dateParts[0] + ' ' + timePart
}
export const timeFilter = range => teetime => {
    const { minSelected: min, maxSelected: max } = range;
    const { time: _time } = teetime;
    const time = isAppleDevice ? formatDateTimeForIOS(_time) : _time;
    const hour = (new Date(time)).getHours()
    const minuets =  (new Date(time)).getMinutes()
    const hourInRange = gte(hour, min) && lte(hour, max);
    const overUpperBound = hour === max
        ? minuets === 0
            ? false : true
        : false
    return hourInRange & !overUpperBound
}

export const priceFilter = range => teetime => {
    const { minSelected: min, maxSelected: max } = range;
    const { greensFees: { Value: price } } = teetime;
    return gte(price, min) && lte(price, max)
}

export const holeCountFilter = count => teetime => !count ? true : count === teetime.holes;

export const golfCartSelectionFilter = _enum => teetime => {
    const cartIncluded = teetime.transportation === 'Cart Included';
    return !_enum
        ? true
        : cartIncluded
            ? _enum === 1
            : _enum === 2;
}

export const golferCountFilter = count => teetime => !count ? true : contains(count, teetime.golfers);

function filterTeeTimes(filters, teetimes) {
    const {
        timeRange,
        priceRange,
        holeCountSelection,
        golfCartSelection,
        golferCount
    } = filters;
    return compose(
        filter(golferCountFilter(golferCount)),
        filter(golfCartSelectionFilter(parseInt(golfCartSelection, 10))),
        filter(holeCountFilter(parseInt(holeCountSelection, 10))),
        filter(priceFilter(priceRange)),
        filter(timeFilter(timeRange))
    )(teetimes)
}

export default filterTeeTimes


// WEBPACK FOOTER //
// ./src/lib/filter-teetimes.js